import { useLinked } from "@type-r/react";
import { Button, Flex, navigate, PrimaryButton } from "lqx-react/lib";
import React from "react";
import { ButtonsBlock, StatusDialog } from "../components/item-card-styles";
import { ValidationRuleItem } from "../api/validationRuleItem";
import { preventDefaultAndStopPropagation } from "../shared";

export const ValidationRulesActions = ({ validationCard, onDelete }:
    { validationCard: ValidationRuleItem, onDelete?: any }) => {
    const toggleValidationSetStatus = async () => {
        await validationCard.switchStatus();
    }

    const ValidationStatusToggleButton = ({ onClick }) => {
        if (validationCard) {
            const $isOpen = useLinked(false);
            const btnColor = validationCard.isActive ? "red" : "blue";
            const btnText = validationCard.isActive ? "Deactivate" : "Activate";
            const title = validationCard.isActive ? "Deactivate Validation" : "Activate Validation";
            const text = validationCard.isActive ?
                "Are you sure you want to Deactivate this Validation Set?" :
                "Are you sure you want to Activate this Validation Set?";
            return <>
                <PrimaryButton
                    disabled={$isOpen.value}
                    onClick={(e) => { preventDefaultAndStopPropagation(e); $isOpen.set(true) }}
                    color={btnColor}>{btnText}
                </PrimaryButton>
                {$isOpen.value ? <StatusDialog $isOpen={$isOpen} onClick={onClick} text={text} title={title} /> : null}
            </>
        }
        else return <></>
    }

    return <>
        <ButtonsBlock>
            <Flex column justifyCenter>
                <ValidationStatusToggleButton onClick={(e) => { preventDefaultAndStopPropagation(e); toggleValidationSetStatus() }} />
            </Flex>
            <Flex column justifyCenter>
                <Button color="primary" onClick={() => navigate(`validation-rules/edit/${validationCard.id}`)}>Edit</Button>
            </Flex>
            {onDelete ? <Button onClick={(e) => { preventDefaultAndStopPropagation(e); onDelete(validationCard.id) }} color="primary">Delete</Button> : <></>}
        </ButtonsBlock>
    </>
};